import AirDatepicker from 'air-datepicker';
import lozad from "lozad";

export function initSearchLanding() {
    const AJAX_MODE = 'prod';

    const $newsWrapper = $('[data-news-wrapper]');
    const $photosWrapper = $('[data-photos-wrapper]');
    const $videosWrapper = $('[data-videos-wrapper]');
    const $errorBlock = $('[data-search-error]');
    const $searchInput = $('#search_input');
    const $clearSearchField = $('#clear_search_field');
    const $filterBlock = $('#date_filter');
    const $applyFilter = $filterBlock.find('[data-apply-date-filter]');
    const $loadMoreButton = $('[data-get-more-search-items]');
    const filterSettings = $filterBlock.data('settings');
    const $mainTitle = $('[data-search-title]');
    let $filterDate;
    const filterValue = {};

    init();

    function init() {
        initDatePicker();
        initHandlers();
        getAllSearchItems();
    }

    function getAllSearchItems() {
        $('#page_preloader').removeClass('hide');
        getSearchItems(1);
        getSearchItems(2);
        getSearchItems(3);
    }

    function getSearchItems(type, isLoadMoreAjax = false) {
        let searchValue = $searchInput.val();

        //для запуска поиска при переходе с главной - смотрим гет параметры
        if (window.location.search.includes('search_query')) {
            searchValue = window.location.search.split('search_query')[1].replace('=', '');
            $searchInput.val(decodeURIComponent(searchValue));
        }

        let ajaxUrl = `/poisk-po-saytu/?type=${type}&search_query=${searchValue}`;

        if (isLoadMoreAjax) {
            const countParameter = getCountGETParameter(type);
            ajaxUrl = `/poisk-po-saytu/?type=${type}&search_query=${searchValue}${countParameter}`;
        }

        //если есть фильтр
        if (Object.keys(filterValue).length !== 0) {
            ajaxUrl = ajaxUrl + `&from=${filterValue.from}&to=${filterValue.to}`;
            $mainTitle.text(`Результаты поиска c ${filterValue.from} по ${filterValue.to}`);

        }else{
            $mainTitle.text(`Результаты поиска`);
        }

        $.ajax({
            url: ajaxUrl,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            success: (data) => {
                if (data?.result && data?.result.length) {
                    successFn(data);
                } else {
                    errorFn();
                }
            },
            error: (data) => {
                errorFn();
            },
        });

        function successFn(data) {
            renderSearchItems(type, data, isLoadMoreAjax);
        }

        function errorFn(data) {
            if(AJAX_MODE === 'dev'){
                data = mockUp[type];
                successFn(data);
                return
            }

            //если поиск - скрываем блок и показываем сообщение
            if (!isLoadMoreAjax) {
                if (type === 1) {
                    $newsWrapper.parent().addClass('hide');

                } else if (type === 2) {
                    $photosWrapper.parent().addClass('hide');

                } else if (type === 3) {
                    $videosWrapper.parent().addClass('hide');

                }

                //для дозагрузки - скрываем кнопку в зависимости от типа
            } else {
                $(`[data-get-more-search-items="${type}"]`).addClass('hided');
            }

            //если мы скрыли все блоки - выводим сообщение, что ничего не найдено
            if (isAllSectionsHided()) {
                $errorBlock.removeClass('hide');
            }

            $('#page_preloader').addClass('hide');

            function isAllSectionsHided() {
                return $newsWrapper.parent().hasClass('hide') &&
                    $photosWrapper.parent().hasClass('hide') &&
                    $videosWrapper.parent().hasClass('hide');
            }
        }
    }

    function initDatePicker() {
        const minDate = new Date(filterSettings.from);
        const maxDate = new Date(filterSettings.to);

        $filterDate = new AirDatepicker('#date_from_cal', {
            minDate,
            maxDate,
            onSelect({date}) {
                let currentMaxDate;

                //костыль, потому что при ините - это объект даты начала, а потом массив из 1 элемента кек
                if (!Array.isArray(date) || date.length === 1) {
                    currentMaxDate = new Date(date) || new Date(date[0]);
                    currentMaxDate = new Date(currentMaxDate.setFullYear(currentMaxDate.getFullYear() + 1));

                    //если вычисленный макс больше верхнего значения даты - посдтавляем верхнее знач{
                    if(currentMaxDate > maxDate){
                        currentMaxDate = maxDate;
                    }
                }

                $filterDate.update({
                    range: true,
                    multipleDatesSeparator: ' - ',
                    maxDate: currentMaxDate
                });

                if (date.length > 1) {
                    filterValue.from = new Date(date[0]).toLocaleDateString();
                    filterValue.to = new Date(date[1]).toLocaleDateString();
                }
            }
        })

        /*const calendarTo = new AirDatepicker('#date_to_cal', {
            onSelect({date}) {
                calendarTo.update({
                    range: true,
                    multipleDatesSeparator: ' - ',
                    maxDate: filterSettings.to
                })
            }
        })*/
    }

    function renderSearchItems(searchType, data, isLoadMoreAjax) {
        //1-новости
        //2-фото
        //3-видео

        let result = '';

        switch (searchType) {
            case 1:
                $newsWrapper.parent().removeClass('hide');
                data.result.forEach(newsItem => {
                    let tagsHTML = '';

                    if(newsItem.tag && newsItem.tag.length){
                        newsItem.tag.forEach(tagItem => {
                            tagsHTML += `<div class="content text">${tagItem}</div>`;
                        });

                        tagsHTML = '<div class="inscription">' + tagsHTML + '</div>';
                    }

                    result += `
                        <div class="col w-50-desktop w-50-tablet">
                            <a class="news-item" href="${newsItem.link}">
                                <div class="img lozad" data-background-image="${newsItem.image}">
                                    ${tagsHTML}
                                </div>
                                <div class="info">
                                    <div class="date">${newsItem.date}</div>
                                    <div class="title">${newsItem.title}</div>
                                    <div class="text">${newsItem.description}</div>
                                </div>
                            </a>
                        </div>`;
                });

                if (isLoadMoreAjax) {
                    $newsWrapper.append(result);

                } else {
                    $newsWrapper.html(result);
                }

                break;

            case 2:
                $photosWrapper.parent().removeClass('hide');
                data.result.forEach(photosItem => {
                    let tagsHTML = '';

                    if(photosItem.tag && photosItem.tag.length){
                        photosItem.tag.forEach(tagItem => {
                            tagsHTML += `<div class="content text">${tagItem}</div>`;
                        });

                        tagsHTML = '<div class="inscription">' + tagsHTML + '</div>';
                    }

                    result += `
                        <div class="col w-33-desktop w-50-tablet">
                            <a class="photo-item" href="${photosItem.link}">
                                <div class="img lozad" data-background-image="${photosItem.image}">
                                    ${tagsHTML}
                                </div>
                                <div class="title">${photosItem.title}</div>
                                <div class="date">${photosItem.date}</div>
                            </a>
                        </div>`;
                });


                if (isLoadMoreAjax) {
                    $photosWrapper.append(result);

                } else {
                    $photosWrapper.html(result);
                }
                break;

            case 3:
                $videosWrapper.parent().removeClass('hide');
                data.result.forEach(videoItem => {
                    let tagsHTML = '';

                    if(videoItem.tag && videoItem.tag.length){
                        videoItem.tag.forEach(tagItem => {
                            tagsHTML += `<div class="content text">${tagItem}</div>`;
                        });

                        tagsHTML = '<div class="inscription">' + tagsHTML + '</div>';
                    }

                    result += `
                        <div class="col w-50-desktop w-50-tablet">
                           <a class="video-item" href="${videoItem.link}">
                               <div class="img lozad" data-background-image="${videoItem.image}">
                                    ${tagsHTML}
                               </div>
                               <div class="title">${videoItem.title}</div>
                           </a>
                        </div>`;
                });


                if (isLoadMoreAjax) {
                    $videosWrapper.append(result);

                } else {
                    $videosWrapper.html(result);
                }

                $('#page_preloader').addClass('hide');
                break;

        }

        //скрываем кнопку дозагрузки, если remains = 0
        if (!data?.remains) {
            $(`[data-get-more-search-items="${searchType}"]`).addClass('hided');

        } else {
            $(`[data-get-more-search-items="${searchType}"]`).removeClass('hided');
        }

        const observer = lozad('.lozad', {});
        observer.observe();
        $errorBlock.addClass('hide');
    }

    function initHandlers() {
        //запуск "поиска"
        $searchInput.on('keydown', function (e) {
            if (e.key === 'Enter') {
                //удаляем гет параметр при ручном поиске
                window.history.pushState('name', '', window.location.href.split("?")[0]);
                getAllSearchItems();
            }
        });

        //чистка инпута и фильтра
        $clearSearchField.on('click', function () {
            $searchInput.val('');
            $filterDate.clear();
            $('#show_filter').removeClass('applied');
            delete filterValue.from;
            delete filterValue.to;
        });

        //показ фильтра
        $('#show_filter').on('click', function () {
            $filterBlock.toggleClass('show');
        });

        //дозагрузка
        $loadMoreButton.on('click', function () {
            const loadMoreType = $(this).data('get-more-search-items');
            getSearchItems(loadMoreType, true);
        });

        //применение фильтра
        $applyFilter.on('click', function () {
            if ($searchInput.val() !== '') {
                getAllSearchItems();
                $('#show_filter').addClass('applied');
                $filterBlock.removeClass('show');
            }
        });
    }

    function getCountGETParameter(type) {
        let currentItemsLength = 0;
        switch (type) {
            case 1:
                currentItemsLength = $newsWrapper.find('.col').length;
                break;

            case 2:
                currentItemsLength = $photosWrapper.find('.col').length;
                break;

            case 3:
                currentItemsLength = $videosWrapper.find('.col').length;
                break;

        }

        return `&curPos=${currentItemsLength}`;
    }

    const mockUp = {
        '1':{
            remains: 896,
            result:[
                {
                    date: "25 августа 2022",
                    description: "По всем вопросам можно обращаться к специалисту по работе с болельщиками «<strong class='matched'>Крыльев</strong> Советов» Алексею Иванову, тел.: +7 (917) 016-45-78.",
                    image: "/netcat_files/8/14/20220501ae.jpg",
                    link: "/news/novosti_1279.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | <strong class='matched'>Новости</strong> и медиа",
                    title: "Вниманию болельщиков, собирающихся в Москву на кубковый матч со «Спартаком»",
                    tag: ["Добрые Крылья 1", "Добрые Крылья 2", "Добрые Крылья 3", "Добрые Крылья 4", "Добрые Крылья 5"]
                },
                {
                    date: "25 августа 2022",
                    description: "Оформите карту болельщика. Уважаемые болельщики!",
                    image: "/netcat_files/8/14/20220807_0.jpg",
                    link: "/news/novosti_1280.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | <strong class='matched'>Новости</strong> и медиа",
                    title: "Оформите карту болельщика",
                }
            ]
        },
        '2':{
            remains: 1,
            result:[
                {
                    date: "15 августа 2022",
                    description: "<strong class='matched'>ФОТО</strong>: 5 тур. Локомотив – КС – 1:1",
                    image: "/netcat_files/8/14/20222518.jpg",
                    link: "/news/novosti_1248.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | Новости и медиа",
                    title: "ФОТО: 5 тур. Локомотив – КС – 1:1",
                    tag: ["Добрые Крылья 1", "Добрые Крылья 2", "Добрые Крылья 3", "Добрые Крылья 4", "Добрые Крылья 5"]
                },
                {
                    date: "19 августа 2022",
                    description: "<strong class='matched'>ФОТО</strong>: 6 тур. КС – Факел – 1:1",
                    image: "/netcat_files/8/14/20222685.jpg",
                    link: "/news/novosti_1268.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | Новости и медиа",
                    title: "ФОТО: 6 тур. КС – Факел – 1:1"
                }
            ]
        },
        '3':{
            remains: 10,
            result:[
                {
                    date: "19 августа 2022",
                    description: "Уберите камеру! «<strong class='matched'>Крылья</strong> Советов» – «Факел»",
                    image: "/netcat_files/8/14/20220819b.jpg",
                    link: "/news/novosti_1267.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | Новости и медиа",
                    title: "Уберите камеру! «Крылья Советов» – «Факел»",
                    tag: ["Добрые Крылья 1", "Добрые Крылья 2", "Добрые Крылья 3", "Добрые Крылья 4", "Добрые Крылья 5"]
                },
                {
                    date: "19 августа 2022",
                    description: "Пресс-конференция после матча «<strong class='matched'>Крылья</strong> Советов» – «Факел»",
                    image: "/netcat_files/8/14/20220819a.jpg",
                    link: "/news/novosti_1264.html",
                    test: "<strong class='matched'>Крылья</strong> Советов | Новости и медиа",
                    title: "Пресс-конференция после матча «Крылья Советов» – «Факел»"
                }
            ]
        }
    }
}